// AuthGuard.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom"; // Importe o Outlet
import useAuth from "../hooks/useAuth";

function AuthGuard() { // Você não precisa mais do { children }
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Carregando...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    window.location.href = '/sign-in';
    return;
  }

  return <Outlet />;

}

export default AuthGuard;